const SUBURBS = [
  { slug: "joondalup", name: "Joondalup" },
  { slug: "fremantle", name: "Fremantle" },
  { slug: "rockingham", name: "Rockingham" },
  { slug: "mandurah", name: "Mandurah" },
  { slug: "scarborough", name: "Scarborough" },
  { slug: "canning-vale", name: "Canning Vale" },
  { slug: "baldivis", name: "Baldivis" },
  { slug: "ellenbrook", name: "Ellenbrook" },
  { slug: "morley", name: "Morley" },
  { slug: "midland", name: "Midland" },
  { slug: "hillarys", name: "Hillarys" },
  { slug: "karrinyup", name: "Karrinyup" },
  { slug: "dianella", name: "Dianella" },
  { slug: "wanneroo", name: "Wanneroo" },
  { slug: "clarkson", name: "Clarkson" },
  { slug: "butler", name: "Butler" },
  { slug: "alkimos", name: "Alkimos" },
  { slug: "mindarie", name: "Mindarie" },
  { slug: "duncraig", name: "Duncraig" },
  { slug: "sorrento", name: "Sorrento" },
  { slug: "subiaco", name: "Subiaco" },
  { slug: "claremont", name: "Claremont" },
  { slug: "cottesloe", name: "Cottesloe" },
  { slug: "floreat", name: "Floreat" },
  { slug: "city-beach", name: "City Beach" },
  { slug: "applecross", name: "Applecross" },
  { slug: "booragoon", name: "Booragoon" },
  { slug: "willetton", name: "Willetton" },
  { slug: "south-perth", name: "South Perth" },
  { slug: "victoria-park", name: "Victoria Park" },
  { slug: "belmont", name: "Belmont" },
  { slug: "bayswater", name: "Bayswater" },
  { slug: "mount-lawley", name: "Mount Lawley" },
  { slug: "leederville", name: "Leederville" },
  { slug: "north-perth", name: "North Perth" },
  { slug: "balcatta", name: "Balcatta" },
  { slug: "stirling", name: "Stirling" },
  { slug: "innaloo", name: "Innaloo" },
  { slug: "doubleview", name: "Doubleview" },
  { slug: "churchlands", name: "Churchlands" },
  { slug: "wembley", name: "Wembley" },
  { slug: "como", name: "Como" },
  { slug: "gosnells", name: "Gosnells" },
  { slug: "armadale", name: "Armadale" },
  { slug: "byford", name: "Byford" },
  { slug: "secret-harbour", name: "Secret Harbour" },
  { slug: "warnbro", name: "Warnbro" },
  { slug: "ocean-reef", name: "Ocean Reef" },
  { slug: "currambine", name: "Currambine" },
  { slug: "padbury", name: "Padbury" },
  { slug: "greenwood", name: "Greenwood" },
  { slug: "landsdale", name: "Landsdale" },
  { slug: "banksia-grove", name: "Banksia Grove" },
  { slug: "mullaloo", name: "Mullaloo" },
  { slug: "gwelup", name: "Gwelup" },
  { slug: "kallaroo", name: "Kallaroo" },
];

const ANGLES = [
  "older character homes with ageing copper and galvanised pipework",
  "coastal air that's tough on outdoor taps and exposed pipework",
  "big blocks, long driveways and mains that love to hide leaks underground",
  "busy family homes where a mystery water bill can sneak up fast",
  "renovated bathrooms and laundries where waterproofing gets put to the test",
  "retic-heavy gardens that can mask a sneaky underground leak for months",
];

export const suburbAngle = (slug) => {
  const i = Math.abs([...slug].reduce((a, c) => a + c.charCodeAt(0), 0)) % ANGLES.length;
  return ANGLES[i];
};

export default SUBURBS;
